import icon_plus_white from "../../assets/images/icon_plus_white.svg";
import { message, Upload, Input, Progress } from "antd";
import { useRef, useState } from "react";
import { staticImg } from "../../siteData/users";
import PopComponent from "../../pages/popContent";
import CustomModal from "../../hoc/CustomModal";
const { TextArea } = Input;

const CustomTextarea = ({ label, uploadLabel, customClass, uploadValue, errors, progress, ...rest }) => {
    const [error, setError] = useState({});
    const [modalName, setModalName] = useState("UserInfo");
    let Modal = PopComponent[modalName];
    const [openModal, setModalOpen] = useState(false);
    const uploadList = useRef(null);

    const handleUpload = (file) => {
        if (!file.type.match(/png|jpeg|jpg/g)) {
            handleOpenModal('ErrorPop', { header: "Info", body: 'Please add only png, jpg or jpeg files' })
        }
    };

    const handleOpenModal = (type, data) => {
        let flag = 0;
        switch (type) {
            case 'ErrorPop': {
                setModalName(type);
                setError(data)
                setModalOpen(!openModal);
                break;
            }
            default: {
                setModalName(type);
                setModalOpen(!openModal);
                break;
            }
        }
        if (flag === 1) {
            setModalName(type);
            setModalOpen(!openModal);
        }
    };


    return (
        <div className="form_group">
            <div className={`form_label  ${customClass}`}>
                <label htmlFor="">{label}</label>
                {
                    uploadLabel && (
                        <>
                            <label htmlFor="">{uploadLabel}</label>
                            <Upload ref={uploadList} accept={rest?.accept} customRequest={(e) => rest.onChange({ file: e, type: "file", name: "avatar", id: rest.id })} beforeUpload={handleUpload} showUploadList={false} className="bio_file_upload file_upload mb_3">
                                <div className="file_upload_button">
                                    {!uploadValue &&
                                        <span>
                                            {
                                                uploadList?.current?.fileList?.[uploadList.current.fileList?.length - 1]?.percent &&
                                                    uploadList?.current?.fileList?.[uploadList.current.fileList?.length - 1]?.percent !== 100 ?
                                                    <Progress width={50} showInfo={false} type="circle" percent={uploadList?.current?.fileList?.[uploadList.current.fileList?.length - 1]?.percent} /> :
                                                    <img src={icon_plus_white} alt="" />
                                            }
                                        </span>
                                    }
                                    {
                                        uploadList?.current?.fileList?.[uploadList.current.fileList?.length - 1]?.percent &&
                                            uploadList?.current?.fileList?.[uploadList.current.fileList?.length - 1]?.percent !== 100 ?
                                            <div className="sample_video_thumb">
                                                <span className="uploaded_thumb_img">
                                                    <Progress width={50} showInfo={false} type="circle" percent={uploadList?.current?.fileList?.[uploadList.current.fileList?.length - 1]?.percent} />
                                                </span>
                                            </div> :
                                            uploadValue && (
                                                <div className="sample_video_thumb">
                                                    <span className="uploaded_thumb_img  cursor_pointer">
                                                        <img src={uploadValue || staticImg} alt="Video thumb" className="img_fluid img_object_center radius_5" height="85" width="85" />
                                                    </span>
                                                </div>
                                            )
                                    }
                                </div>
                            </Upload>
                        </>
                    )
                }
            </div>
            <div className="form_input">
                <TextArea {...rest} className="" maxLength={1500} showCount={true} rows="8" />
                <div className="errMsg">{errors}</div>
            </div>
            {
                Modal && (
                    <CustomModal className={`${modalName === 'EditThoughtLeader' || modalName === 'AddThoughtLeader' ? "ant-modal modal peak_model thought_leader_modal" : "modal skill_model"} ${modalName === 'ErrorPop' ? 'errorPop' : ''}`} handleOpen={handleOpenModal} open={openModal}>
                        <Modal
                            error={error}
                            handleOpenModal={handleOpenModal}
                        />
                    </CustomModal>
                )
            }
        </div>
    )
};

export default CustomTextarea